<template>
  <div v-if="visibility || $config.editMode" class="editorial-immersive__grid" :class="getLayoutClasses" :ref="`id-${uuid}`">
    <figure v-if="image" class="editorial-immersive__grid-item  editorial-immersive__figure" :style="getGridStyle">
      <pg-image v-if="!isMobile" :lazy-src="image | mgnlMedia('url')" :alt="altImage"></pg-image>
      <pg-image v-else-if="isMobile" :lazy-src="getFallbackImage | mgnlMedia('url')" :alt="altImage" class="mobile"></pg-image>
    </figure>
    <div class="editorial-immersive__grid-item editorial-immersive__text" :style="getGridStyle">
      <component
          :is="subheadingTag"
          class="editorial-immersive__grid__subheading editorial-immersive__grid__subheading--upper text--heading-s"
          v-if="upperSubtitle && !hideUpperSubtitle"
      >{{upperSubtitle}}
      </component>
      <component :is="headingTag" :class="headingClass" v-if="title">{{title}}</component>
      <component
          :is="subheadingTag"
          class="editorial-immersive__grid__subheading text--heading-s"
          v-if="subtitle"
      >{{subtitle}}
      </component>
      <div class="text--body" v-html="text"></div>
      <div v-if="ctaLinks && ctaLinks.length > 0" class="editorial-immersive__grid__cta margin-top__btn-m margin-bottom__btn-m">
        <span v-for="ctaObj in ctaLinks" :key="ctaObj.uuid">
          <advanced-button-wrapper :cta-obj="ctaObj" color="primary" styleType="text" size="medium" :sectionStyle="sectionStyle" :analyticsData="analyticsData(ctaObj)"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import AdvancedButtonWrapper from "../Advanced-Button-Wrapper/Advanced-Button-Wrapper";
  import PgImage  from "../Image/Image.vue";

  export default {
    name: "EditorialHorizontalImmersive",
    data() {
      return {
        actionParam: null
      }
    },
    components: {
      AdvancedButtonWrapper,
      PgImage
    },
    props: {
      uuid: {
        type: String
      },
      upperSubtitle: {
        type: String
      },
      hideUpperSubtitle: {
      type: Boolean
      },
      title: {
        type: String
      },
      subtitle: {
        type: String
      },
      text: {
        type: String
      },
      ctaLinks: {
        type: Array,
        required: false,
        default: () => []
      },
      image: {
        type: Object,
        required: false,
        default: null
      },
      imageMobile: {
        type: Object,
        required: false,
        default: null
      },
      altImage: {
        type: String,
        defaultValue: "",
        required: false
      },
      layout: {
        type: String
      },
      headingStyle: {
        type: String
      },
      sectionStyle: {
        type: String
      },
      fullImage: {
        type: Boolean,
        default: false
      },
      actpageFullUrl: {
        type: String,
      },
      visibility: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      getFallbackImage() {
        return !this.imageMobile ? this.image : this.imageMobile;
      },
      getGridStyle() {
        return !this.isMobile ? "--aspect-ratio: 4/3;" : "--aspect-ratio: 3/4;"
      },
      isMobile() {
        return window.matchMedia('only screen and (max-width: 640px)').matches;
      },
      headingClass() {
        return this.headingStyle === "large"
            ? "editorial-immersive__grid__title text--heading-l"
            : "editorial-immersive__grid__title text--heading-m";
      },
      headingTag() {
        return this.headingStyle === "large" ? "h2" : "h3"; //simplified heading hierarchy for accessibility purpose
      },
      subheadingTag() {
        return this.headingStyle === "large" ? "p" : "p"; //simplified heading hierarchy for accessibility purpose
      },
      getLayoutClasses() {
        return [
          this.fullImage ? "editorial-immersive__grid-fullImage" : "",
          `editorial-immersive__${this.layout}`
        ]
      }
    },
    methods: {
      isInViewport(elem) {
        const rect = elem.getBoundingClientRect();
        const html = document.documentElement;
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
      },
      scrollToAnchor(targetId) {

        if (targetId == `id-${this.uuid}`) {
          const anchor = this.$refs[targetId];

          if (!anchor) return;
          const marginToTop = 144;
          const bounding = anchor.getBoundingClientRect();
          let distanceToTop = Math.floor(bounding.top - marginToTop);

          if (window.pageYOffset === 0) {
            distanceToTop -= 62;
          }

          anchor.parentElement.tabIndex = -1;
          anchor.parentElement.focus();

          window.scrollBy({top: distanceToTop, left: 0, behavior: "smooth"});

        }
      },
      onPageScrolling() {
        const ctx = this;
        window.requestAnimationFrame(() => {
          // Run scroll functions
          const anchor = document.getElementById(`uuid-${ctx.uuid}`);
          if (ctx.isInViewport(anchor)) {
            ctx.$eventHub.emit('editorial:elementInViewport', ctx.uuid);
          }
        });
      },
      analyticsData(el) {
        return {
          evCategory: 'call_to_action',
          evAction: el.document?.url || el.link?.url || el.trackingLabel,
          evLabel: `${el.campaignId || 'No Campaign'} | ${this.actpageFullUrl}`
        }
      }
    },
    mounted() {
      // Listen for message events
      this.$eventHub.on("anchor:scrollTo", (targetId) => {
        this.scrollToAnchor(targetId);
      });
      // Listen for scroll events
      if (this.upperSubtitle) {
        window.addEventListener("scroll", this.onPageScrolling);
      }
    },
    destroyed() {
      window.removeEventListener("scroll", this.onPageScrolling);
    }
  };
</script>